import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].GET_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/quality_controls/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].GET_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/quality_controls/:qualityControlId/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/quality_controls/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].PUT_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/quality_controls/:qualityControlId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/quality_controls/:qualityControlId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/quality_controls/:qualityControlId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

}